
import { handleError, error, receive, request } from '../../lib/Utils';

import Swagger from 'swagger-client';
import { callApi } from '../../lib/SwaggerApi';

let SwaggerApi = new Swagger('/api/docs');
export const GET_ACCESSORIAL_SHEET = {
  REQUEST: "GET_ACCESSORIAL_SHEET_REQUEST",
  SUCCESS: "GET_ACCESSORIAL_SHEET_SUCCESS",
  FAILURE: "GET_ACCESSORIAL_SHEET_FAILURE"
};

export const GET_ACCESSORIAL_SHEET_TXT = {
  REQUEST: "GET_ACCESSORIAL_SHEET_TXT_REQUEST",
  SUCCESS: "GET_ACCESSORIAL_SHEET_TXT_SUCCESS",
  FAILURE: "GET_ACCESSORIAL_SHEET_TXT_FAILURE"
};

export const UPDATE_ACCESSORIAL_SHEET = {
  REQUEST: "UPDATE_ACCESSORIAL_SHEET_REQUEST",
  SUCCESS: "UPDATE_ACCESSORIAL_SHEET_SUCCESS",
  FAILURE: "UPDATE_ACCESSORIAL_SHEET_FAILURE"
};

export const IMPORT_ACCESSORIAL_SHEET = {
  REQUEST: "IMPORT_ACCESSORIAL_SHEET_REQUEST",
  SUCCESS: "IMPORT_ACCESSORIAL_SHEET_SUCCESS",
  FAILURE: "IMPORT_ACCESSORIAL_SHEET_FAILURE"
};
/*
export function getAccessorials(parameters, callback = () => false) {
  return (dispatch) => {
    dispatch(request(GET_ACCESSORIAL_SHEET));
    SwaggerApi.then(client => {
      client.apis.Accessorials.getAccessorials(parameters)
        .then(payload => {
          if (payload.ok) {
            dispatch(receive(GET_ACCESSORIAL_SHEET, payload.body));
            callback(null, payload.body);
          } else {
            handleError(dispatch, payload, GET_ACCESSORIAL_SHEET, callback);
          }
        }).catch((err) => {
          dispatch(error(GET_ACCESSORIAL_SHEET, { status: 0, message: err.message }));
          callback(err);
        });
    }).catch(err => {
      dispatch(error(GET_ACCESSORIAL_SHEET, { status: 0, message: err.message }));
      callback(err);
    });
  };
}
*/

export function getAccessorials(parameters, callback = () => false) {
  return callApi(parameters, "Accessorials", "getAccessorials", GET_ACCESSORIAL_SHEET, callback);
}

export function getAccessorialsTXT(parameters, callback = () => false) {
  return callApi(parameters, "Accessorials", "getAccessorials", GET_ACCESSORIAL_SHEET_TXT, callback);
}


export function importJSON(parameters, callback  = () => false ) {
  return (dispatch) => {
    dispatch(request(IMPORT_ACCESSORIAL_SHEET));

    var formData = new FormData();
    formData.append('file', parameters.file);

    let putCSVLink = `/api/accessorials?terminalId=${parameters.terminalId}&orgId=${parameters.orgId}&fileFormat=csv`;

    return fetch(putCSVLink, {
      method: 'PUT',
      body: formData,
      credentials: 'same-origin'
    }).then((payload) => {
      if (payload.ok) {
        payload.json().then(json =>{
          dispatch(receive(IMPORT_ACCESSORIAL_SHEET, json));          
          callback(null, json);
        });
        
      }
      else {
        handleError(dispatch, payload, IMPORT_ACCESSORIAL_SHEET, callback);
      }
    })
      .catch(function (err) {
        dispatch(error(IMPORT_ACCESSORIAL_SHEET, {
          message: err.message
        }));
        callback(err);
      });
  };
}


export function updateAccessorial(parameters, callback) {
  return (dispatch) => {
    dispatch(request(UPDATE_ACCESSORIAL_SHEET));
    SwaggerApi.then(client => {
      client.apis.Accessorials.updateAccessorial(parameters)
        .then(payload => {
          if (payload.ok) {
            dispatch(receive(UPDATE_ACCESSORIAL_SHEET, payload.body));
            callback(null, payload.body);
          } else {
            handleError(dispatch, payload, UPDATE_ACCESSORIAL_SHEET, callback);
          }
        }).catch((err) => {
          dispatch(error(UPDATE_ACCESSORIAL_SHEET, { status: 0, message: err.message }));
          callback(err);
        });
    }).catch(err => {
      dispatch(error(GET_ACCESSORIAL_SHEET, { status: 0, message: err.message }));
      callback(err);
    });
  };
}



// WEBPACK FOOTER //
// ./src/containers/AccessorialsAndFees/AccessorialsAndFeesActions.js